import {
  ref, onMounted, onUnmounted,
} from '@vue/composition-api'

const helperFn = (key1, key2, successFunction) => {
  const pressedKeys = ref(new Set())
  let keyTimer = null

  const clearPressedKeys = () => {
    pressedKeys.value.clear()
    clearTimeout(keyTimer)
    keyTimer = null
  }

  const startKeyTimer = () => {
    keyTimer = setTimeout(() => {
      clearPressedKeys()
    }, 1000)
  }

  const handleKeyDown = event => {
    const { activeElement } = document
    if (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.isContentEditable) {
      return
    }

    const key = event.key.toLowerCase()

    if (key === key1 && pressedKeys.value.size === 0) {
      pressedKeys.value.add(key)
      startKeyTimer()
    } else if (
      key === key2
      && pressedKeys.value.has(key1)
    ) {
      pressedKeys.value.add(key)
      if (pressedKeys.value.size === 2) {
        successFunction()
        clearPressedKeys()
      }
    }
  }

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown)
  })

  onUnmounted(() => {
    window.removeEventListener('keydown', handleKeyDown)
  })
}

export default function useAccessibilityShortCuts(context) {
  // Handle authorization
  helperFn('f', 'd', () => {
    context.root.$bvModal.show('driver-accessibility-modal')
  })
  helperFn('f', 'u', () => {
    context.root.$bvModal.show('user-accessibility-modal')
  })
  helperFn('f', 't', () => {
    context.root.$bvModal.show('trip-accessibility-modal')
  })
}
